import { FieldAppSDK } from '@contentful/app-sdk'
import { TextInput } from '@contentful/f36-components'
import { useSDK } from '@contentful/react-apps-toolkit'
import { useEffect, useRef, useState } from 'react'
import { generateArticleId } from '../../utils/generateArticleId'

export const DefaultEntryField = () => {
  const sdk = useSDK<FieldAppSDK>()
  const hasGeneratedRef = useRef(false)
  const [value, setValue] = useState<string>(sdk.field.getValue() ?? '')

  useEffect(() => {
    try {
      const contentType = sdk.ids?.contentType
      const fieldId = sdk.ids?.field
      const isTargetField = contentType === 'helpCenterArticle' && fieldId === 'articleId'
      const isNewEntry = sdk.entry.getSys().publishedVersion === undefined
      const currentValue = sdk.field.getValue()

      if (!hasGeneratedRef.current && isTargetField && isNewEntry && !currentValue) {
        hasGeneratedRef.current = true
        const generatedId = generateArticleId()
        setValue(generatedId)
        void sdk.field.setValue(generatedId)
      } else if (currentValue) {
        setValue(currentValue)
      }

      sdk.window.updateHeight(0)
    } catch (err) {
      console.error('Error generating article ID:', err)
    }
  }, [sdk])

  useEffect(() => {
    return sdk.field.onValueChanged(nextValue => {
      setValue(nextValue ?? '')
    })
  }, [sdk])

  return <TextInput value={value} isDisabled />
}